import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

// Re-export feature-specific hooks
export * from './hooks/use-product-variant-table'
export * from './hooks/use-product-variants'
export * from './hooks/useOptimisticUpdate'
